/*! DO NOT EDIT: This file is auto-generated and will be overwritten. [build-fingerprint:assets:source={/app/_js/standalone/reviews/index.js}] */
"use strict";
(() => {
  // _js/standalone/reviews/index.js
  document.addEventListener("DOMContentLoaded", () => {
    if (window.innerWidth < 768) {
      let elem = document.querySelector(".main-carousel"), flkty = new Flickity(elem, {
        // options
        cellAlign: "center",
        contain: !0,
        groupCells: 1,
        wrapAround: !0,
        adaptiveHeight: !0,
        prevNextButtons: !1
      }), previousButton = document.querySelector(".is-previous"), nextButton = document.querySelector(
      ".is-next");
      previousButton.addEventListener("click", () => {
        flkty.previous();
      }), nextButton.addEventListener("click", () => {
        flkty.next();
      });
    }
  });
})();
